import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {PhoneIcon} from '@/components/common/icons/PhoneIcon'
import {UserIcon} from '@/components/common/icons/UserIcon'
import {UserAvatar} from '@/components/header/user/UserAvatar'
import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'
import {formatPhoneNumber} from '@/utils/formatting/phone-number'
import {UserForUserFragment} from '@/utils/graphqlSdk'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type AccountInfoCardProps = {
  user: UserForUserFragment
}

export const AccountInfoCard: FC<AccountInfoCardProps> = ({user}) => {
  const fullName = [user.profile?.firstname, user.profile?.lastname].filter(Boolean).join(' ')
  const phone = formatPhoneNumber(user.profile?.phone_number)

  return (
    <>
      <div className="summary">
        <div className="avatar">
          <UserAvatar isClickable={false} />
        </div>
        <div className="details">
          <Text
            mobileVariant={TextVariant.text14}
            fontWeight={TextFontWeight.bold}
            className="truncated"
          >
            {user.email}
          </Text>
          {(fullName || phone) && (
            <div className="wrapper">
              {fullName && (
                <div className="meta">
                  <UserIcon size={IconSize.small} color={theme.palette.text.light} />
                  <Text variant={TextVariant.text14} color={theme.palette.text.light}>
                    {fullName}
                  </Text>
                </div>
              )}
              {phone && (
                <div className="meta">
                  <PhoneIcon size={IconSize.small} color={theme.palette.text.light} />
                  <Text variant={TextVariant.text14} color={theme.palette.text.light}>
                    {phone}
                  </Text>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .summary {
          display: flex;
          align-items: center;
          gap: ${theme.spacing[2.5]};
          padding: ${theme.spacing[2.5]} ${theme.spacing[2.5]};
          border-radius: 8px;
          background-color: ${theme.palette.gray[100]};
        }
        .details {
          flex: 1;
          min-width: 0;
        }
        .wrapper {
          display: flex;
          flex-wrap: wrap;
          margin-top: ${theme.spacing[0.5]};
        }
        .meta {
          display: flex;
          align-items: center;
          gap: ${theme.spacing[1.5]};
        }
        .meta:not(:last-child)::after {
          content: '';
          width: 4px;
          height: 4px;
          background-color: ${theme.palette.gray[300]};
          border-radius: 50%;
          margin-left: ${theme.spacing[2]};
          margin-right: ${theme.spacing[2.5]};
        }
        @media ${MOBILE_SCREENSIZE} {
          .wrapper {
            flex-direction: column;
            gap: ${theme.spacing[1]};
            margin-top: ${theme.spacing[1]};
          }
          .avatar,
          .meta:not(:last-child)::after {
            display: none;
          }
        }
      `}</style>
    </>
  )
}
